<template>
    <div class="card border-left-0 border-right-0 border-bottom-0 mb-4">
        <div class="card-header bg-white d-flex justify-content-between align-items-center">
            <h3 class="m-0">
                <slot name="title" />
            </h3>
            <div>
                <slot name="actions" />
            </div>
        </div>
        <div class="card-body">
            <slot />
        </div>
    </div>
</template>

<script>
export default {};
</script>

<style lang="scss">
.card {
    border-top-width: 2px;

    .card-header {
        height: 60px;
    }
}
</style>
